import PropTypes from 'prop-types'
import React from 'react'

function SelectFilterStatus({ filterAction }) {
  return (
    <div className="col-lg-3 col-sm-12 input-group">
      <select className="custom-select" onChange={e => filterAction(e.target.value)}>
        <option defaultValue value="0">
          Tudo
        </option>
        <option value="1">Publicado</option>
        <option value="2">Rascunho</option>
      </select>
    </div>
  )
}

SelectFilterStatus.propTypes = {
  filterAction: PropTypes.func.isRequired
}

export default SelectFilterStatus
